module.exports = __webpack_public_path__ + "5b7520998390e5952aadb3c8d8148f6d.webp";